/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createMatrixClass } from '../../factoriesAny.js';
export var MatrixDependencies = {
  createMatrixClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesMatrixClass.generated.js
// module id = NSSK
// module chunks = 3